export const USER_LOADING = "USER_LOADING"
export const USER_LOADED = "USER_LOADED"
export const AUTH_ERROR = "AUTH_ERROR"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAIL = "LOGIN_FAIL"
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS"
export const REGISTER_SUCCESS = "REGISTER_SUCCESS"
export const REGISTER_LOADING = "REGISTER_LOADING"
export const REGISTER_FAIL = "REGISTER_FAIL"

export const IS_INITIAL_POPULAR_MOVIES_LOADING = "IS_INITIAL_POPULAR_MOVIES_LOADING"
export const IS_INITIAL_POPULAR_MOVIES_SUCCESS = "IS_INITIAL_POPULAR_MOVIES_SUCCESS"
export const IS_INITIAL_POPULAR_MOVIES_FAIL = "IS_INITIAL_POPULAR_MOVIES_FAIL"
export const FETCH_MORE_POPULAR_MOVIES_SUCCESS = "FETCH_MORE_POPULAR_MOVIES_SUCCESS"
export const FETCH_MORE_POPULAR_MOVIES_LOADING = "FETCH_MORE_POPULAR_MOVIES_LOADING"
export const FETCH_MORE_POPULAR_MOVIES_ERROR = "FETCH_MORE_POPULAR_MOVIES_ERROR"

export const IS_INITIAL_TOP_RATED_MOVIES_LOADING = "IS_INITIAL_TOP_RATED_MOVIES_LOADING"
export const IS_INITIAL_TOP_RATED_MOVIES_SUCCESS = "IS_INITIAL_TOP_RATED_MOVIES_SUCCESS"
export const IS_INITIAL_TOP_RATED_MOVIES_FAIL = "IS_INITIAL_TOP_RATED_MOVIES_FAIL"
export const FETCH_MORE_TOP_RATED_MOVIES_SUCCESS = "FETCH_MORE_TOP_RATED_MOVIES_SUCCESS"
export const FETCH_MORE_TOP_RATED_MOVIES_LOADING = "FETCH_MORE_TOP_RATED_MOVIES_LOADING"
export const FETCH_MORE_TOP_RATED_MOVIES_ERROR = "FETCH_MORE_TOP_RATED_MOVIES_ERROR"

export const IS_INITIAL_NOW_PLAYING_MOVIES_LOADING = "IS_INITIAL_NOW_PLAYING_MOVIES_LOADING"
export const IS_INITIAL_NOW_PLAYING_MOVIES_SUCCESS = "IS_INITIAL_NOW_PLAYING_MOVIES_SUCCESS"
export const IS_INITIAL_NOW_PLAYING_MOVIES_FAIL = "IS_INITIAL_NOW_PLAYING_MOVIES_FAIL"
export const FETCH_MORE_NOW_PLAYING_MOVIES_SUCCESS = "FETCH_MORE_NOW_PLAYING_MOVIES_SUCCESS"
export const FETCH_MORE_NOW_PLAYING_MOVIES_LOADING = "FETCH_MORE_NOW_PLAYING_MOVIES_LOADING"
export const FETCH_MORE_NOW_PLAYING_MOVIES_ERROR = "FETCH_MORE_NOW_PLAYING_MOVIES_ERROR"

export const IS_INITIAL_UPCOMING_MOVIES_LOADING = "IS_INITIAL_UPCOMING_MOVIES_LOADING"
export const IS_INITIAL_UPCOMING_MOVIES_SUCCESS = "IS_INITIAL_UPCOMING_MOVIES_SUCCESS"
export const IS_INITIAL_UPCOMING_MOVIES_FAIL = "IS_INITIAL_UPCOMING_MOVIES_FAIL"
export const FETCH_MORE_UPCOMING_MOVIES_SUCCESS = "FETCH_MORE_UPCOMING_MOVIES_SUCCESS"
export const FETCH_MORE_UPCOMING_MOVIES_LOADING = "FETCH_MORE_UPCOMING_MOVIES_LOADING"
export const FETCH_MORE_UPCOMING_MOVIES_ERROR = "FETCH_MORE_UPCOMING_MOVIES_ERROR"


export const DELETE_WATCHLIST_SUCCESS = "DELETE_WATCHLIST_SUCCESS"
export const IS_WATCHLIST_FETCHING = "IS_WATCHLIST_FETCHING"
export const IS_WATCHLIST_SUCCESS = "IS_WATCHLIST_SUCCESS"
export const IS_WATCHLIST_ERROR = "IS_WATCHLIST_ERROR"
export const IS_NEW_WATCHLIST = "IS_NEW_WATCHLIST"
export const CLEAR_ALL_WATCHLIST = "CLEAR_ALL_WATCHLIST"

export const DELETE_RATEDMOVIES_SUCCESS = "DELETE_RATEDMOVIES_SUCCESS"
export const IS_RATEDMOVIES_FETCHING = "IS_RATEDMOVIES_FETCHING"
export const IS_RATEDMOVIES_SUCCESS = "IS_RATEDMOVIES_SUCCESS"
export const IS_RATEDMOVIES_ERROR = "IS_RATEDMOVIES_ERROR"
export const IS_NEW_RATEDMOVIES = "IS_NEW_RATEDMOVIES"
export const CLEAR_ALL_RATEDMOVIES = "CLEAR_ALL_RATEDMOVIES"


